import React from 'react';
import { motion } from 'framer-motion';
import { ArrowIcon } from './icons/ArrowIcon';
interface CTAButtonProps {
  text?: string;
  subtext?: string;
}
export function CTAButton({
  text = 'Accedé ahora al Master',
  subtext = '🔒 Garantía De 7 Días'
}: CTAButtonProps) {
  const scrollToPrice = () => {
    const element = document.getElementById('precio');
    if (element) {
      const headerOffset = 60;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <div className="w-full flex justify-center py-8 md:py-12" data-id="element-37">
      <motion.button onClick={scrollToPrice} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className="relative inline-flex flex-col items-center justify-center gap-2 px-10 py-6 rounded-xl md:rounded-2xl overflow-hidden group" style={{
      background: 'linear-gradient(135deg, #E5A5A0 0%, #D4AF7A 100%)',
      boxShadow: '0 4px 20px rgba(229, 165, 160, 0.4), 0 8px 40px rgba(212, 175, 122, 0.3), inset 0 2px 0 rgba(255, 255, 255, 0.2)',
      border: '2px solid rgba(212, 175, 122, 0.4)'
    }} data-id="element-38">
        {/* Animated golden border glow */}
        <div className="absolute inset-0 rounded-xl md:rounded-2xl" style={{
        background: 'linear-gradient(135deg, #D4AF7A, #F5E6D3, #D4AF7A, #F5E6D3)',
        backgroundSize: '300% 300%',
        animation: 'gradient-shift 3s ease infinite',
        padding: '2px',
        WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
        WebkitMaskComposite: 'xor',
        maskComposite: 'exclude',
        opacity: 0.5
      }} data-id="element-39" />

        {/* Outer glow effect */}
        <div className="absolute inset-0 rounded-xl md:rounded-2xl" style={{
        boxShadow: '0 0 20px rgba(212, 175, 122, 0.5), 0 0 40px rgba(229, 165, 160, 0.3)',
        animation: 'pulse-glow-branded 2s ease-in-out infinite'
      }} data-id="element-40" />

        {/* Glass shine overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-white/20 via-transparent to-transparent rounded-xl md:rounded-2xl" data-id="element-41" />

        {/* Animated shine sweep */}
        <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/25 to-transparent rounded-xl md:rounded-2xl" animate={{
        x: ['-100%', '200%']
      }} transition={{
        duration: 3,
        repeat: Infinity,
        repeatDelay: 1,
        ease: 'easeInOut'
      }} data-id="element-42" />

        <span className="relative flex items-center justify-center gap-2 text-xl md:text-2xl font-bold text-white tracking-tight text-center" style={{
        textShadow: '0 2px 8px rgba(61, 48, 40, 0.4), 0 1px 2px rgba(61, 48, 40, 0.3)'
      }} data-id="element-43">
          {text}
          <ArrowIcon className="w-5 h-5 md:w-6 md:h-6 group-hover:translate-x-1 transition-transform duration-300" data-id="element-44" />
        </span>
        <span className="relative text-sm md:text-base font-semibold tracking-wide text-center text-white/95" style={{
        textShadow: '0 1px 4px rgba(61, 48, 40, 0.3)'
      }} data-id="element-45">
          {subtext}
        </span>
      </motion.button>

      <style jsx data-id="element-46">{`
        @keyframes pulse-glow-branded {
          0%,
          100% {
            box-shadow:
              0 0 20px rgba(212, 175, 122, 0.4),
              0 0 40px rgba(229, 165, 160, 0.25);
          }
          50% {
            box-shadow:
              0 0 30px rgba(212, 175, 122, 0.6),
              0 0 60px rgba(229, 165, 160, 0.4);
          }
        }

        @keyframes gradient-shift {
          0%,
          100% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
        }
      `}</style>
    </div>;
}